import {
  Box,
  Grid,
  TextField,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Checkbox,
  Button,
  Modal,
  IconButton,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { Controller, useForm, useWatch, useFieldArray } from "react-hook-form";
import React, { useEffect, useState } from "react";
import OAuth2Authenticator from "../Auth2Authenticator/OAuth2Authenticator";
import {
  getSettings,
  upsertSetting,
} from "../../../../APICalling/OtherCalling";
import { EXTENSION_IDENTIFIER } from "../../../../config/serviceConstant";
import { getOpenSnakErrorData } from "../../../../config/otherConstant";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const ConnectionDetails = ({
  service,
  orgId,
  apiKey,
  dataCenter,
  zApiKey,
  setSnack,
  currentUser,
  handlefetchConnections,
}) => {
  const [serviceAuth, setServiceAuth] = useState(false);
  const [open, setOpen] = useState(false);
  const [submitData, setSubmitData] = useState();
  const [settingId, setSettingId] = useState();
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [showSearchInput, setShowSearchInput] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [scopeError, setScopeError] = useState(false);

  const handleClear = () => {
    setSearchText(""); // Clear the text field
  };
  const handleSearchClick = () => {
    // setShowSearchInput(!showSearchInput);
    setShowSearchInput((prev) => !prev);
  };
  // const { handleSubmit, control, reset, getValues, setValue, formState: { errors } } = useForm({
  //   defaultValues: {
  //     connName: "",
  //     connApiName: "",
  //     scopes: service?.scopes?.map((scope) => {
  //       return { scope: scope };
  //     }),
  //   },
  // });
  const {
    handleSubmit,
    control,
    reset,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      connName: "",
      connApiName: "",
      scopes: service?.scopes?.map((scope) => {
        return { scope: scope };
      }),
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "scopes",
  });

  const scopsWatch = useWatch({
    control,
    name: "scopes",
  });

  // useEffect(() => {
  //   setValue(
  //     "connApiName",
  //     getValues("connName")?.split(" ")?.join("_")?.split("__")?.join("_")
  //   );
  // }, [getValues("connName")]);

  const onSubmit = async (data) => {
    const selectedScopes = data?.scopes?.filter(
      (socopeCheckbox) => socopeCheckbox?.value
    );
    if (selectedScopes.length === 0) {
      setScopeError(true);
      return;
    } else {
      setScopeError(false);
    }
    console.log({ service });
    // create setting
    let headers = {
      orgId,
      apiKey,
      connname: EXTENSION_IDENTIFIER,
    };
    let bodyData = {
      settingSchema: {
        service,
        data,
      },
      moduleApiName: data?.connApiName,
      settingType: "customConnection",
    };
    let params = { moduleApiName: data?.connApiName };
    const previousSettings = await getSettings({ headers, params });
    if (previousSettings?.data) {
      // todo show error regarding same api name
      setSnack(
        getOpenSnakErrorData("Error!!! Duplicate Connection Name", 10 * 1000)
      );
      return;
    }

    const settingResp = await upsertSetting({ headers, data: bodyData });
    console.log({ settingResp: settingResp?.data?.setting_id });

    setSettingId((prev) => settingResp?.data?.setting_id);
    let scopes = data?.scopes
      ?.filter((socopeCheckbox) => socopeCheckbox?.value)
      ?.map((socopeCheckbox) => socopeCheckbox?.scope?.name);
    let tempSubmitData = {
      ...data,
      scopes,
    };
    setSubmitData((prev) => tempSubmitData);
    setOpen((prev) => true);
    /*
     */
  };

  return (
    <Box sx={{ marginTop: "20px" }}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={6}>
            <Typography
              sx={{ fontWeight: "bold", marginBottom: "8px", fontSize: "15px" }}
            >
              Enter Connection Name
            </Typography>
            <Controller
              name="connName"
              control={control}
              defaultValue=""
              rules={{ required: "Connection Name is required" }}
              render={({ field }) => (
                <>
                  <TextField
                    id="standard-basic"
                    size="small"
                    // label="folder name"
                    variant="outlined"
                    required
                    error={!!errors.connName} // Show error if validation fails
                    helperText={errors.connName ? errors.connName.message : ""}
                    {...field}
                    onChange={(event) => {
                      // if (!event?.target?.checked) {
                      //   setValue('information.saveFolder.value', null);
                      // }
                      // setValue(`information.saveFolder.value`, null);
                      // reset({
                      //   firstName: "bill",
                      //   lastName: "luo",
                      // })
                      // resetField("information.saveFolder.value")
                      // setValue("information.saveFolder.value", null);
                      field.onChange(event?.target?.value);
                      setValue(
                        "connApiName",
                        event?.target?.value
                          ?.split(" ")
                          ?.filter((data) => data)
                          ?.join("_")
                          ?.split("_")
                          ?.filter((data) => data)
                          ?.join("_")
                      );
                    }}
                    fullWidth
                  />
                </>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Typography
              sx={{ fontWeight: "bold", marginBottom: "8px", fontSize: "15px" }}
            >
              Enter Connection Link Name
            </Typography>

            <Controller
              name="connApiName"
              control={control}
              defaultValue=""
              rules={{ required: "Connection Link Name is required" }}
              render={({ field }) => (
                <>
                  <TextField
                    id="standard-basic"
                    size="small"
                    // label="folder name"
                    variant="outlined"
                    disabled
                    required
                    error={!!errors.connApiName} // Show error if validation fails
                    helperText={
                      errors.connApiName ? errors.connApiName.message : ""
                    }
                    {...field}
                    fullWidth
                  />
                </>
              )}
            />
          </Grid>
        </Grid>
        <Typography mt={3} sx={{ fontWeight: "bold", fontSize: "15px" }}>
          Choose Scopes
        </Typography>

        <Box
          mt={1}
          sx={{
            boxShadow:
              "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
            border: scopeError ? "1px solid red" : "none",
          }}
        >
          <Box
            p={1}
            sx={{ bgcolor: "#F8FAFE", display: "flex", alignItems: "center" }}
          >
            {/* Left section for SCOPES text */}
            <Box width={"97%"} sx={{ display: "flex", alignItems: "center" }}>
              <Typography color={"gray"} fontSize={13}>
                SCOPES
              </Typography>
            </Box>

            {/* Right section for search box and search icon */}
            <Box
              // width={"20%"}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <Box
                sx={{
                  width: showSearchInput ? "200px" : "0px",
                  transition: "width 0.3s ease",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <TextField
                  size="small"
                  placeholder="Search here..."
                  variant="outlined"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  InputProps={{
                    endAdornment: searchText && (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClear}
                          edge="end"
                          size="small"
                        >
                          <ClearIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    opacity: showSearchInput ? 1 : 0,
                    transition: "opacity 0.3s ease 0.1s",
                    width: "200px",
                  }}
                />
              </Box>

              {/* Search Icon Button */}
              <IconButton
                sx={{
                  backgroundColor: "#f5f7fa",
                  borderRadius: 1,
                  "&:hover": { backgroundColor: "#f0f0f0" },
                  ml: 1,
                }}
                onClick={handleSearchClick}
              >
                <SearchIcon />
              </IconButton>
            </Box>
          </Box>

          <Box
            p={2}
            sx={{
              height: "100px", // Set fixed height
              overflowY: "auto", // Enable vertical scrolling if content exceeds height
              scrollbarWidth: "thin", // Optionally make scrollbar thinner
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#888",
                borderRadius: "10px",
              },
            }}
          >
            {fields.map((item, index) => (
              <ul key={item.id} style={{ padding: "0", margin: "0" }}>
                <Controller
                  name={`scopes.${index}.value`}
                  control={control}
                  render={({ field, fieldState, formState }) => (
                    <>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={field.value}
                            {...field}
                            disableRipple
                            size="small"
                            onChange={(event) => {
                              // if (!event?.target?.checked) {
                              //   setValue('information.saveFolder.value', null);
                              // }
                              // setValue(`information.saveFolder.value`, null);
                              // reset({
                              //   firstName: "bill",
                              //   lastName: "luo",
                              // })
                              // resetField("information.saveFolder.value")
                              // setValue("information.saveFolder.value", null);
                              field.onChange(event?.target?.checked);
                            }}
                          />
                        }
                        // label={scopsWatch?.[index]?.scope?.displayName}
                        label={
                          <Typography sx={{ fontSize: "14px" }}>
                            {scopsWatch?.[index]?.scope?.displayName}
                          </Typography>
                        }
                        sx={{ margin: "0", padding: "0 8px" }}
                      />
                    </>
                  )}
                />
              </ul>
            ))}
          </Box>
        </Box>
        {scopeError && (
          <Typography color="red" fontSize={12} mt={1}>
            Value must be selected
          </Typography>
        )}

        <Box pl={10} pt={5} sx={{ display: "flex", justifyContent: "end" }}>
          <Button
            type="submit"
            variant="contained"
            sx={{
              marginTop: "10px",
              bgcolor: "#1976D2",
              textTransform: "none",
            }}
          >
            Create And Connect
          </Button>
          <Button
            sx={{
              color: "#757575",
              bgcolor: "#eeeeee",
              marginTop: "10px",
              marginLeft: "20px",
              mr: 2,
              textTransform: "none",
            }}
          >
            Cancel
          </Button>
        </Box>

        {/* <div style={{ display: "flex", justifyContent: "end" }}>
          <Button sx={{ marginTop: "10px", mr: 2, color: "#1850A0" }}>
            Cancel
          </Button>
          <Button
            sx={{ marginTop: "10px", bgcolor: "#1976D2" }}
            type="submit"
            variant="contained"
          >
            Create
          </Button>
        </div> */}
      </form>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Authenticate {service?.name}
          </Typography>
          <OAuth2Authenticator
            serviceAuth={serviceAuth}
            setServiceAuth={setServiceAuth}
            orgId={orgId}
            apiKey={apiKey}
            dataCenter={dataCenter}
            zApiKey={zApiKey}
            setSnack={setSnack}
            service={service}
            currentUser={currentUser}
            submitData={submitData}
            settingId={settingId}
            handlefetchConnections={handlefetchConnections}
          />
        </Box>
      </Modal>
    </Box>
  );
};

export default ConnectionDetails;
